// FAQ Section JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const faqSection = document.querySelector('.faq-section');
  if (!faqSection) return;

  // Handle accordion animation
  const accordions = faqSection.querySelectorAll('details.accordion');
  
  accordions.forEach(accordion => {
    const summary = accordion.querySelector('summary');
    const content = accordion.querySelector('.accordion__content');
    
    // Smooth animation for accordion open/close
    accordion.addEventListener('toggle', function() {
      if (accordion.open) {
        // Opening animation
        content.style.animation = 'fadeIn 0.3s ease';
      }
    });

    // Prevent multiple accordions open at once (optional)
    // Uncomment below if you want only one FAQ open at a time
    /*
    summary.addEventListener('click', function(e) {
      const isOpen = accordion.open;
      
      if (!isOpen) {
        accordions.forEach(otherAccordion => {
          if (otherAccordion !== accordion && otherAccordion.open) {
            otherAccordion.open = false;
          }
        });
      }
    });
    */
  });

  // Track FAQ interactions (Analytics)
  accordions.forEach((accordion, index) => {
    const summary = accordion.querySelector('summary');
    
    summary.addEventListener('click', function() {
      const question = summary.textContent.trim();
      const isOpening = !accordion.open;
      
      // Send to analytics if available
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'faq_interaction',
          faq_question: question,
          faq_action: isOpening ? 'open' : 'close',
          faq_position: index + 1
        });
      }
    });
  });

  // Smooth scroll to FAQ if hash in URL
  if (window.location.hash && window.location.hash.startsWith('#faq-')) {
    setTimeout(() => {
      const targetId = window.location.hash.substring(1);
      const target = document.getElementById(targetId);
      
      if (target && target.closest('.faq-section')) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Open the accordion
        const details = target.closest('details');
        if (details) {
          details.open = true;
        }
      }
    }, 300);
  }
});

// Add CSS animation keyframes dynamically
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);

